import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Form, Input, Button, App} from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import http from "../../services/http";

const ResetPassword = () => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const onFinish = async (values) => {
    const { password, confirmPassword } = values;

    if (password !== confirmPassword) {
      message.error("Mật khẩu không khớp");
      return;
    }

    if (!token) {
      message.error("Mã đặt lại không hợp lệ hoặc bị thiếu");
      return;
    }

    setLoading(true);

    try {
      await http.post("/api/doctor/reset-password", {
        resetToken: token,
        newPassword: password,
        confirmPassword: confirmPassword,
      });

      message.success("Đặt lại mật khẩu thành công");

      // Redirect to login after 2 seconds
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      console.error("Lỗi đặt lại mật khẩu:", err);
      message.error(
        err?.message || "Không thể đặt lại mật khẩu. Mã thông báo có thể đã hết hạn."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/images/logo.png"
            alt="MedRev Logo"
            className="h-16 w-auto mx-auto mb-6"
          />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Đặt mật khẩu mới
          </h1>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-lg shadow-sm p-8">
          <Form
            layout="vertical"
            onFinish={onFinish}
            requiredMark={false}
            className="space-y-4"
          >
            <Form.Item
              label={
                <span className="text-gray-700 text-sm">
                  Nhập mật khẩu mới của bạn
                </span>
              }
              name="password"
              rules={[
                { required: true, message: "Vui lòng nhập mật khẩu của bạn" },
                { min: 8, message: "Mật khẩu phải có ít nhất 8 ký tự" },
              ]}
            >
              <Input.Password
                placeholder="Nhập mật khẩu mới của bạn"
                className="py-2.5"
                size="large"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item
              label={
                <span className="text-gray-700 text-sm">Xác nhận mật khẩu</span>
              }
              name="confirmPassword"
              rules={[
                { required: true, message: "Vui lòng xác nhận mật khẩu của bạn" },
              ]}
            >
              <Input.Password
                placeholder="Xác nhận mật khẩu"
                className="py-2.5"
                size="large"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="w-full bg-purple-600 hover:bg-purple-700 h-11 font-medium rounded-lg text-base mt-4"
                size="large"
              >
                Đặt lại mật khẩu
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
